/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteContractorPenaltyCommand } from '../../models/delete-contractor-penalty-command';
import { DeleteContractorPenaltyCommandResult } from '../../models/delete-contractor-penalty-command-result';

export interface ApiContractorPenaltiesDeleteContractorPenaltyDelete$Params {
      body?: DeleteContractorPenaltyCommand
}

export function apiContractorPenaltiesDeleteContractorPenaltyDelete(http: HttpClient, rootUrl: string, params?: ApiContractorPenaltiesDeleteContractorPenaltyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteContractorPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiContractorPenaltiesDeleteContractorPenaltyDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteContractorPenaltyCommandResult>;
    })
  );
}

apiContractorPenaltiesDeleteContractorPenaltyDelete.PATH = '/api/ContractorPenalties/DeleteContractorPenalty';
